module.exports = __webpack_public_path__ + "img/Silver.2861de98.png";